import http from "../helpers/http-common"

class AdminService {

    addAction(params) {
        return http.post(`/system/actions/add`, params);
    }

    getOperators() {
        return http.get('/system/operators/list');
    }

    getActions(params) {
        return http.post(`/system/actions/list`, params);
    }

    getActionsStats(params) {
        return http.post(`/system/actions/stats`, params);
    }
}

export default new AdminService();